import { Trans } from '@lingui/macro';
import FormSection from '../../form/FormSection';
import NgpToggle from '../../form/NgpToggle';
import { CAC_LOCAL_ENABLED_FIELD } from './SsoAdminConstants';

export default function CacLocal() {
    return (
        <>
            <FormSection title={<Trans>Server Configuration</Trans>}>
                <NgpToggle
                    fieldName={CAC_LOCAL_ENABLED_FIELD}
                    label={<Trans>Enabled</Trans>}
                    helpTipText={
                        <Trans>
                            At least one System Admin user must be a valid CAC user, with username containing the
                            assocated EPIDI
                        </Trans>
                    }
                />
            </FormSection>
        </>
    );
}
